import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { navigateHistory } from '../redux/thunk/appNavThunk';
import './NavButtons.scss';

const ChevronLeft = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="15 18 9 12 15 6" />
    </svg>
);

const ChevronRight = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="9 18 15 12 9 6" />
    </svg>
);

const NavButtons = () => {
    const dispatch = useDispatch();
    const { navIndex, navStack } = useSelector((s) => s.app);
    const canGoBack = navIndex > 0;
    const canGoForward = navIndex < navStack.length - 1;

    // NOTE: these are role="button" divs, not <button>s, on purpose. This
    // component renders inside the last react-bootstrap <Tab>'s title, which
    // react-bootstrap emits as a <button class="nav-link">. Real nested
    // <button>s are invalid DOM (validateDOMNesting warning) and break
    // focus/click behavior — so we use ARIA buttons with keyboard handling.
    const activate = (direction, enabled) => (e) => {
        if (!enabled) return;
        if (e.type === 'keydown') {
            if (e.key !== 'Enter' && e.key !== ' ') return;
            e.preventDefault();
        }
        dispatch(navigateHistory(direction));
    };

    return (
        <div className="nav-history-btns">
            <div
                className="nav-history-btn"
                role="button"
                tabIndex={canGoBack ? 0 : -1}
                aria-disabled={!canGoBack}
                onClick={activate('back', canGoBack)}
                onKeyDown={activate('back', canGoBack)}
                title="Back"
                aria-label="Back"
            >
                <ChevronLeft />
            </div>
            <div
                className="nav-history-btn"
                role="button"
                tabIndex={canGoForward ? 0 : -1}
                aria-disabled={!canGoForward}
                onClick={activate('forward', canGoForward)}
                onKeyDown={activate('forward', canGoForward)}
                title="Forward"
                aria-label="Forward"
            >
                <ChevronRight />
            </div>
        </div>
    );
};

export default NavButtons;
